import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "game-home-page"
};
const _hoisted_2 = {
  class: "left-wrap"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "menu-line-wrap"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "menu-line"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "menu-line"
})], -1);
const _hoisted_4 = {
  class: "left-menu-wrap"
};
const _hoisted_5 = {
  class: "menu-list"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "center-wrap"
};
const _hoisted_8 = {
  class: "center-header-wrap"
};
const _hoisted_9 = {
  class: "content-wrap"
};
const _hoisted_10 = {
  class: "content-center-wrap"
};
const _hoisted_11 = {
  class: "provider-list"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "notice-wrap notice-bg"
}, null, -1);
const _hoisted_14 = {
  class: "scroll-view with-provider"
};
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "blank-block"
}, null, -1);
const _hoisted_16 = {
  key: 1
};
const _hoisted_17 = {
  class: "withdraw-event-container"
};
import { ref, watch, inject, onMounted, onUnmounted } from 'vue';
import ws from '@/connect';
import { usePageVisibility } from '@vant/use';
import { useHelpTool } from '@/hooks';
import { useUserStore, useAccountStore } from "@/store";
import UserProfile from './components/UserProfile';
import Balance from '@/components/Common/Balance';
import HomeTopMenu from './components/HomeTopMenu';
import HomeRightMenu from './components/HomeRightMenu';
import WithdrawEvent from './components/WithdrawEvent';
import { queryGameType, queryGameProvider, queryGameList, queryGameHot, queryGameNew, queryGameCollect, queryNotice, collectGame, cancelCollectGame } from "@/api";
export default {
  __name: 'index',
  setup(__props) {
    const HOT_LIST = [{
      code: 'HOT',
      name: 'HOT',
      icon: require('@/assets/img/home/hot-text.png')
    }, {
      code: 'NEW',
      name: 'NEW',
      icon: require('@/assets/img/home/new-text.png')
    }, {
      code: 'LIKE',
      name: 'LIKE',
      icon: require('@/assets/img/home/like-text.png')
    }];
    const MENU_SETTING = {
      default: {
        showProvider: true,
        showType: 0
      },
      live: {
        showProvider: false,
        showType: 1
      },
      sports: {
        showProvider: false,
        showType: 2
      }
    };
    const hideCover = inject('hideCover');
    const pageVisibility = usePageVisibility();
    const {
      doEnterGame
    } = useHelpTool();
    const userStore = useUserStore();
    const accountStore = useAccountStore();
    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false);
    const dataList = ref([]);
    const current = ref(1);
    const pageSize = ref(500);
    const noticeText = ref(''); //notice
    const menuList = ref([]);
    const activeMenu = ref(null);
    const providerList = ref([]);
    const activeProvider = ref(null);
    watch(pageVisibility, (newValue, oldValue) => {
      if (newValue === 'visible') {
        accountStore.fetchBalance();
        userStore.loadUserInfo();
        hideCover.value = false;
      }
    });
    watch(activeMenu, (newValue, oldValue) => {
      if (newValue && newValue.showProvider) {
        fetchGameProvider();
      } else {
        providerList.value = [];
        activeProvider.value = null;
        reloadData();
      }
    });
    watch(activeProvider, (newValue, oldValue) => {
      if (newValue) {
        reloadData();
      }
    });
    onMounted(() => {
      userStore.loadUserInfo(() => {
        ws.connect();
      });
      accountStore.fetchBalance();
      fetchGameType();
      fetchNotice();
    });
    const fetchNotice = () => {
      queryNotice().then(res => {
        let noticeList = res.data || [];
        noticeText.value = noticeList.map(item => item.content).join('\t\t\t');
      });
    };
    const fetchGameType = initType => {
      queryGameType().then(res => {
        let _menuList = res.data || [];
        _menuList = _menuList.map(menu => {
          let setting = MENU_SETTING[menu.code] || MENU_SETTING.default;
          return {
            ...menu,
            ...setting
          };
        });
        menuList.value = _menuList;
        if (_menuList.length > 0) {
          if (initType) {
            _menuList.map(item => {
              if (item.code == initType) {
                activeMenu.value = item;
              }
            });
          } else {
            activeMenu.value = _menuList[0];
          }
        }
      });
    };
    const fetchGameProvider = () => {
      if (activeMenu.value.code === 'hot') {
        providerList.value = HOT_LIST || [];
        activeProvider.value = providerList.value[0];
        return false;
      }
      queryGameProvider({
        type: activeMenu.value.code
      }).then(res => {
        providerList.value = res.data || [];
        if (providerList.value.length > 0) {
          activeProvider.value = providerList.value[0];
        } else {
          activeProvider.value = null;
          finished.value = false;
          refreshing.value = true;
          loadData();
        }
      });
    };
    const fetchGameList = () => {
      var _activeMenu$value, _activeMenu$value2, _activeProvider$value2;
      let doPost = queryGameList;
      if (((_activeMenu$value = activeMenu.value) === null || _activeMenu$value === void 0 ? void 0 : _activeMenu$value.code) === 'hot') {
        var _activeProvider$value;
        let providerCode = (_activeProvider$value = activeProvider.value) === null || _activeProvider$value === void 0 ? void 0 : _activeProvider$value.code;
        if (providerCode === 'HOT') {
          doPost = queryGameHot;
        } else if (providerCode === 'NEW') {
          doPost = queryGameNew;
        } else if (providerCode === 'LIKE') {
          doPost = queryGameCollect;
        }
      }
      doPost({
        pageSize: pageSize.value,
        current: current.value,
        type: (_activeMenu$value2 = activeMenu.value) === null || _activeMenu$value2 === void 0 ? void 0 : _activeMenu$value2.code,
        manuf: (_activeProvider$value2 = activeProvider.value) === null || _activeProvider$value2 === void 0 ? void 0 : _activeProvider$value2.code
      }).then(res => {
        dataList.value = dataList.value.concat(res.data || []);
        if (res.total <= res.page * pageSize.value) {
          finished.value = true;
        } else {
          current.value = res.page + 1;
        }
        loading.value = false;
      });
    };
    const loadData = () => {
      if (refreshing.value) {
        dataList.value = [];
        current.value = 1;
        refreshing.value = false;
      }
      fetchGameList();
    };
    const refreshData = () => {
      // 清空列表数据
      finished.value = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      loading.value = true;
      loadData();
      accountStore.fetchBalance();
    };
    const reloadData = () => {
      finished.value = false;
      refreshing.value = true;
      loadData();
    };
    const toggleCollect = game => {
      let doPost = collectGame;
      if (game.isCollect) {
        doPost = cancelCollectGame;
      }
      doPost({
        gid: game.gid
      }).then(res => {
        var _activeProvider$value3;
        if (((_activeProvider$value3 = activeProvider.value) === null || _activeProvider$value3 === void 0 ? void 0 : _activeProvider$value3.code) === 'LIKE') {
          reloadData();
        } else {
          dataList.value = dataList.value.map(item => {
            if (item.id == game.id) {
              item.isCollect = !item.isCollect;
            }
            return item;
          });
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_loading = _resolveComponent("van-loading");
      const _component_van_notice_bar = _resolveComponent("van-notice-bar");
      const _component_van_empty = _resolveComponent("van-empty");
      const _directive_audio = _resolveDirective("audio");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_unref(UserProfile)), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, item => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(`menu-item ${activeMenu.value && activeMenu.value.code === item.code ? 'active' : ''}`),
          key: item.code,
          onClick: $event => activeMenu.value = item
        }, [_createElementVNode("div", {
          class: _normalizeClass(`menu-item-title ${activeMenu.value.code}`)
        }, _toDisplayString(item.name), 3), _createVNode(_component_van_image, {
          class: "menu-item-icon",
          fit: "contain",
          src: require(`@/assets/img/home/menu/${item.code}.png`)
        }, null, 8, ["src"])], 10, _hoisted_6)), [[_directive_audio]]);
      }), 128))])])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_unref(Balance)), _createVNode(_unref(HomeTopMenu))]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [activeMenu.value && activeMenu.value.showProvider && providerList.value.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(providerList.value, item => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(`provider-item ${activeProvider.value && activeProvider.value.code === item.code ? 'active' : 'inactive'}`),
          key: item.icon,
          onClick: $event => activeProvider.value = item
        }, [_createVNode(_component_van_image, {
          class: "provider-icon",
          fit: "contain",
          src: item.icon
        }, {
          loading: _withCtx(() => [_createVNode(_component_van_loading, {
            type: "spinner",
            color: "#ADB5BF",
            size: "24"
          })]),
          _: 2
        }, 1032, ["src"])], 10, _hoisted_12)), [[_directive_audio]]);
      }), 128)) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_hoisted_13, _createVNode(_component_van_notice_bar, {
        class: "notice-wrap",
        color: "#fff",
        background: "transparent",
        scrollable: "",
        text: noticeText.value
      }, null, 8, ["text"])]), _createElementVNode("div", _hoisted_14, [dataList.value.length > 0 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(`game-list style${activeMenu.value.showType}`)
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "game-block",
          key: item.id
        }, [_withDirectives((_openBlock(), _createBlock(_component_van_image, {
          class: "game-img",
          fit: "cover",
          src: (activeMenu.value.showType === 0 ? item.icon : activeMenu.value.showType === 1 ? item.imgVertical : item.imgHorizontal) || '-',
          "error-icon": require('@/assets/img/common/game.png'),
          onClick: $event => _unref(doEnterGame)(item.gid)
        }, {
          loading: _withCtx(() => [_createVNode(_component_van_loading, {
            type: "spinner",
            color: "#ADB5BF",
            size: "24"
          })]),
          _: 2
        }, 1032, ["src", "error-icon", "onClick"])), [[_directive_audio]]), _withDirectives(_createVNode(_component_van_image, {
          class: "like-icon",
          src: require(`@/assets/img/home/like${item.isCollect ? 'd' : ''}.png`),
          onClick: $event => toggleCollect(item)
        }, null, 8, ["src", "onClick"]), [[_directive_audio]])]);
      }), 128)), _hoisted_15], 2)) : (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_component_van_empty, {
        description: _ctx.$t('common.noData')
      }, null, 8, ["description"])]))])]), _createVNode(_unref(HomeRightMenu))])]), _createElementVNode("div", _hoisted_17, [_createVNode(_unref(WithdrawEvent))])]);
    };
  }
};